import React, { useState, useEffect, lazy, Suspense } from 'react';
import SharedHelmet from ".././Helmet";
import { FirstAds, SecondAds } from "../../Ads";
const BlinkingText = lazy(() => import('../../BlinkingText'));
const RelatedLinks = lazy(() => import('../RelatedLinks'));
const MainCalculatorsList = lazy(() => import('./MainCalculators'));
const TITLE = "كم باقي على كأس آسيا 2027 - العد التنازلي لكأس آسيا";
const DESCRIPTION = "كم باقي على كأس آسيا 2027؟ العد التنازلي لكأس آسيا يتيح لك معرفة الوقت المتبقي حتى بداية البطولة الرياضية الأكبر في قارة آسيا. تابع العد التنازلي وكن على اطلاع حول الموعد المحدد لانطلاق كأس آسيا.";
const KEYWORDS = "كأس آسيا 2027, كم باقي على كأس آسيا, العد التنازلي لكأس آسيا, متى كأس آسيا, كأس آسيا, العد التنازلي للبطولة الآسيوية, موعد كأس آسيا, المباريات كأس آسيا";
const OG_URL = "https://do-calculate.com/articles-ar/asian-cup";
function AFCAsianCupCountdown() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const asianCupDate = new Date("2027-01-12T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(asianCupDate));
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(asianCupDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);
    return (
        <div className="rtl">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>كم باقي على كأس آسيا 2027</h1>
            <Suspense fallback={<div>Loading...</div>}>
                <BlinkingText text="كم باقي على كأس آسيا: من المتوقع أن تبدأ البطولة يوم الخميس 12 يناير 2027 في دولة قطر." />
            </Suspense>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px', textAlign: 'center' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc' }}>
                        <thead>
                            <tr>
                                <th>يوم</th>
                                <th>ساعة</th>
                                <th>دقيقة</th>
                                <th>ثوانٍ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{timeLeft.days}</td>
                                <td>{timeLeft.hours}</td>
                                <td>{timeLeft.minutes}</td>
                                <td>{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>معلومات عن كأس آسيا 2027</h3>
                    <p>
                        كأس آسيا هي البطولة الرياضية الأهم في قارة آسيا لكرة القدم، حيث يتنافس المنتخب الوطني للعديد من الدول الآسيوية للفوز بلقب البطولة. كأس آسيا 2027 ستُقام في دولة قطر، وتعد هذه النسخة مميزة كونها ستكون المرة الثانية التي تستضيف فيها قطر البطولة بعد عام 2011.
                    </p>
                    <p>
                        من المتوقع أن تشهد البطولة مشاركة 24 منتخبًا من مختلف أنحاء قارة آسيا، وأن تكون المنافسات أكثر إثارة من أي وقت مضى.
                    </p>
                    <hr />
                    <Suspense fallback={<div>Loading...</div>}>
                        <RelatedLinks />
                    </Suspense>
                </div>
                <div className="col">
                    <Suspense fallback={<div>Loading...</div>}>
                        <MainCalculatorsList />
                    </Suspense>
                </div>
            </div>
        </div>
    );
}
export default AFCAsianCupCountdown;
